export function getProductTitlePrompt(productDescription: string) {
  return `
Generate a concise product title, maximum 10 words, based on the following description:

<PRODUCT_DESCRIPTION>${productDescription}</PRODUCT_DESCRIPTION>
  `;
}
